import type {SystemStyleObject} from '@chakra-ui/styled-system';

import {$bgColor, $borderColor, $borderWidth} from '../theme/css-vars';

export const GraphHandleStyle: SystemStyleObject = {
  [`.react-flow__handle`]: {
    width: `12px`,
    height: `12px`,
    bgColor: $bgColor.reference,
    borderStyle: `solid`,
    borderWidth: $borderWidth.reference,
    // TODO: consider this as the default border color
    borderColor: $borderColor.reference,
  },
  [`.react-flow__handle-right`]: {
    right: `-7px`,
  },
  [`.react-flow__handle-left`]: {
    left: `-7px`,
  },
};
